import * as React from 'react'
import { useNewsFeed } from '@/modules/shared/hooks/useNewsFeed'
import { NewsItem } from '@/modules/shared/query-client/useQueryNews'
import { WhatsNewPopup } from './WhatsNewPopup'

export const WhatsNewHost: React.FC = () => {
  const {
    unseen,
    shouldAnnounce,
    markAllSeen,
    announcementsMuted,
    setAnnouncementsMuted,
  } = useNewsFeed()

  const [announced, setAnnounced] = React.useState<NewsItem[] | null>(null)
  const alreadyAnnounced = React.useRef(false)

  React.useEffect(() => {
    if (alreadyAnnounced.current || !shouldAnnounce) return
    alreadyAnnounced.current = true
    setAnnounced(unseen)
  }, [shouldAnnounce, unseen])

  const close = React.useCallback(() => {
    setAnnounced(null)
    markAllSeen()
  }, [markAllSeen])

  if (!announced) return null

  return (
    <WhatsNewPopup
      open
      items={announced}
      muted={announcementsMuted}
      onMutedChange={setAnnouncementsMuted}
      onClose={close}
    />
  )
}
